<template>
  <v-dialog :value="true" persistent max-width="450">
    <v-card>
      <v-card-title class="headline">Approve Proof</v-card-title>

      <v-card-text>
        <p>Enter rewards code for your website</p>
        <v-form ref="approveForm">
          <v-text-field v-model="couponCode" :disabled="approveRequestLoading" outlined label="Reward Code" :rules="requiredRule" />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="approveRequestLoading" color="darken-1" text @click="$emit('sway-offer-approve-modal-close')">Close</v-btn>
        <v-btn :loading="approveRequestLoading" color="primary darken-1" text @click="approveSwayOffer()">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { ApiService } from '@/services/index'
import validationRules from '@/utils/validation'

export default Vue.extend({
  name: 'SwayOfferApproveModal',

  props: {
    proofId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    couponCode: '',
    approveRequestLoading: false,
    requiredRule: validationRules.requiredRule,
  }),

  methods: {
    approveSwayOffer() {
      if (!this.$refs.approveForm.validate()) return

      this.approveRequestLoading = true

      ApiService.put(`reverseFlow/proof/approve/${this.proofId}`, { couponCode: this.couponCode }).then(() => {
        this.$emit('sway-offer-approve-modal-proof-approved')
        this.$toast.success(`Proof approved!`)

        this.approveRequestLoading = false
      })
    },
  },
})
</script>
